import { TSelectOption, TFilters, TFilterSelections, TFilterPill } from 'shared/types'
import { createCustomOption } from 'shared/utils/formatDate'

export const filtersSelection = (values: TFilters, defaultValues: TFilters, selectionLabels: TFilterSelections) =>
  Object.keys(values).reduce((acc: TFilterPill[], key: string) => {
    const isArrayValue = Array.isArray(values[key])
    const isCustomRangeValue = key === 'range' && values[key].includes('from')
    const updatedLabel = isArrayValue
      ? values[key]
      : isCustomRangeValue
        ? createCustomOption(values[key]).label
        : selectionLabels[key]?.find((item: TSelectOption) => item.value === values[key])?.label

    if ((isArrayValue && values[key].length) || (!isArrayValue && values[key] !== defaultValues[key])) {
      acc = [...acc, { label: updatedLabel, value: key }]
    }

    return acc
  }, [])
